const brandingKey = 'Setup version';
const brandingKey_BTMU = 'BTMU Setup version';
const defaultBrandingKey = brandingKey;

function setMsgId(prefix, brandingKey){
    let msgId = '';
    let branding;
    if (brandingKey === 'Setup version'){
        msgId = prefix;
    } else {
        branding = brandingKey.replace(/[^a-z]/ig, '');
        msgId = prefix + '_' + branding;
    }
    return msgId;
}

export const msgId = setMsgId('chkMessage', brandingKey);
export const loadedMSIVersionDiv = setMsgId('VersionDiv', brandingKey);
export const warningMsgId = setMsgId('browserWarning', brandingKey);
export const securityWarningId = setMsgId('securityWarning', brandingKey);

// events
export const action = {};
export const message = {};
export const redirect = {};